import { PathHelper } from '@sensenet/client-utils';
import { useEffect, useState } from 'react';
export const usePickerHelper = _ref => {
  let {
    contextPath,
    selectionRoots,
    repository
  } = _ref;
  const [helperPaths, setHelperPaths] = useState([]);
  const [isAncestorOfRoot, setIsAncestorOfRoot] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    const getReferencePickerHelperData = async () => {
      const SelectionRootQueries = [];
      let isContextPathInTree = false;

      for (const root of selectionRoots || []) {
        if (PathHelper.isInSubTree(root, contextPath)) {
          isContextPathInTree = true;
        }

        if (!repository.load) {
          continue;
        }

        const promise = repository === null || repository === void 0 ? void 0 : repository.load({
          idOrPath: root,
          oDataOptions: {
            select: ['Name', 'DisplayName', 'Path']
          }
        });
        SelectionRootQueries.push(promise);
      }

      try {
        const promiseResult = await Promise.allSettled(SelectionRootQueries);
        const fulfilledResults = promiseResult.filter(result => {
          var _result$value;

          return result.status === 'fulfilled' && ((_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.d.Path) !== contextPath;
        }).map(result => result.value.d);
        setHelperPaths(fulfilledResults);
        setIsLoading(false);
        setIsAncestorOfRoot(isContextPathInTree);
      } catch (e) {
        console.error(e);
      }
    };

    getReferencePickerHelperData();
  }, [selectionRoots, contextPath, repository]);
  return {
    helperPaths,
    isAncestorOfRoot,
    isLoading
  };
};
export default usePickerHelper;
//# sourceMappingURL=picker-helper.hook.js.map